import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import productCore from "../core/product.core";
import { getNextProductListPageParam } from "../core/productListInfinite.core";
import { ProductListRes } from "../types/product";

const PAGE_SIZE = 20;

export default function useProductsPointRedeemable() {
  const { isReady, locale } = useRouter();

  const query = useInfiniteQuery({
    queryKey: ["products", locale, "pointRedeemable", PAGE_SIZE],
    initialPageParam: 1,
    queryFn: ({ pageParam }) => productCore.getPointRedeemableProducts(locale, { page: pageParam as number, size: PAGE_SIZE }),
    getNextPageParam: getNextProductListPageParam,
    enabled: isReady,
  });

  const data: ProductListRes | undefined = useMemo(() => {
    const pages = query.data?.pages;
    if (!pages?.[0]) return undefined;
    return { ...pages[0], list: pages.flatMap((p) => p.list) };
  }, [query.data?.pages]);

  return {
    ...query,
    data,
  };
}
